<template>
  <div>
    <div class="pb-5" data-wizard-type="step-content" data-wizard-state="current">
      <div class="row">
        <div class="col-xl-12">
          <h4 class="mb-10" v-if="course.id">Saisissez les informations à modifier</h4>
          <h4 v-else class="mb-10 font-weight-bold text-dark">
            Saisissez les informations à créer en Français
          </h4>
          <!-- <div class="row">
            <div :class="className">
              <FileDrop
                @updateFile="updatePoster"
                :mimeTypes="['image/jpeg', 'image/png']"
                mimeTypesSupported=".jpeg, .jpg, .png"
                mimeError="Veuillez choisir une image au format .jpg, .jpeg, ou .png"
                :fileSizeMaxBytes="2000000"
                fileSizeMax="2Mo"
                fileSizeMaxError="Votre image ne peut dépasser 2Mo"
              ></FileDrop>
            </div>

            <div class="col-xl-3">
              <v-img
                v-if="course.id && newFile == null"
                :src="apiUrl + course.posterPath"
                aspect-ratio="1.1"
                elevation="15"
              ></v-img>
              <v-img
                v-if="newFile != null"
                :src="urlNewFile"
                aspect-ratio="1.1"
                elevation="15"
              ></v-img>
            </div>
          </div> -->
          <div class="form-group">
            <v-text-field
            :rules="titleErrors"
            :counter="150"
              type="text"
              v-model="course.title"
              label="Titre du parcours *"
            />
          </div>
          <div class="form-group">
            <v-textarea
            :rules="descErrors"
              v-model="course.description"
              label="Description du parcours *"

            ></v-textarea>
          </div>
          <div class="form-group">
            <v-switch
                v-model="course.isVisible"
                :label="`Le parcours est : ${course.isVisible ? 'En ligne' : 'Hors ligne'}`"
                color="error"
                hide-details
            ></v-switch>
          </div>
          <!-- <div class="form-text">Tags du parcours *</div>
          <div class="row">
            <div class="col-xl-6">
              <div class="form-group">
                <label><i class="la la-eye"></i> Visibles</label>

                <v-combobox
                  v-model="course.keywords.visibleFR"
                  :items="keywords.visibleFR"
                  label="Tags visibles"
                  multiple
                  chips
                  item-text="name"
                  return-object
                  clearable
                  deletable-chips
                  hide-selected
                  :rules="[required]"
                  ><template v-slot:no-data>
                    <v-list-item>
                      <v-list-item-title>
                        Mot-clé inexistant. Appuyer sur Entrer pour
                        <strong>le créer</strong>
                      </v-list-item-title>
                    </v-list-item>
                  </template></v-combobox
                >
              </div>
            </div>
            <div class="col-xl-6">
              <div class="form-group">
                <label><i class="la la-eye-slash"></i> Invisibles</label>

                <v-combobox
                  v-model="course.keywords.invisibleFR"
                  :items="keywords.invisibleFR"
                  label="Tags invisibles"
                  multiple
                  chips
                  item-text="name"
                  return-object
                  clearable
                  deletable-chips
                  hide-selected
                  :rules="[required]"
                  ><template v-slot:no-data>
                    <v-list-item>
                      <v-list-item-title>
                        Mot-clé inexistant. Appuyer sur Entrer pour
                        <strong>le créer</strong>
                      </v-list-item-title>
                    </v-list-item>
                  </template></v-combobox
                >
              </div>
            </div>
          </div> -->
          <div class="row">
            <div class="col-xl-9"><h5 class="mb-7">Thème </h5></div>
            <div class="col-xl-3 text-end">
              <a
                class="btn btn-light-danger"
                color="primary"
                @click.stop="dialog = true"
              >
                {{
                  !!course.theme && course.theme.length > 0
                    ? "Modifier le thème"
                    : "Ajouter un thème"
                }}
              </a>
            </div>
          </div>
          <div class="row">
            <div class="col-xl-12">
              <div class="form-group">
                <v-simple-table class="elevation-2">
                  <template v-slot:default>
                    <thead>
                      <tr>
                        <th class="text-left">
                          Nom du thème
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="item in course.theme" :key="item.id">
                        <td>{{ item.title }}</td>
                      </tr>
                    </tbody>
                  </template>
                </v-simple-table>
                <p class="mt-3 subtitle-1 font-weight-light">
                  Vous n'aurez pas à choisir à nouveau le thème pour la partie
                  "Anglais"
                </p>
              </div>
            </div>
          </div>

          <!-- Modal pour choisir le thème  -->
          <v-dialog v-model="dialog" max-width="490">
            <v-card class="mx-auto" max-width="500">
              <v-sheet class="pa-4 primary lighten-2">
                <v-text-field
                  v-model="search"
                  label="Rechercher le nom d'un thème..."
                  dark
                  flat
                  solo-inverted
                  hide-details
                  clearable
                  clear-icon="mdi-close-circle-outline"
                ></v-text-field>
                <v-checkbox
                  v-model="caseSensitive"
                  dark
                  hide-details
                  label="Activer la sensibilité à la casse"
                ></v-checkbox>
              </v-sheet>
              <v-card-text>
                <v-treeview
                  :active="course.theme"
                  activatable
                  :items="themes"
                  item-key="id"
                  item-text="title"
                  :search="search"
                  :filter="filter"
                  :open.sync="open"
                  open-on-click
                  @update:active="(selected) => themeSelected(selected)"
                  return-object
                >
                  <template v-slot:prepend="{ item, open }">
                    <v-icon v-if="!item.file">
                      {{ open ? "mdi-folder-open" : "mdi-folder" }}
                    </v-icon>
                    <v-icon v-else>
                      {{ files[item.file] }}
                    </v-icon>
                  </template>
                </v-treeview>
                <v-card-actions>
                  <v-spacer></v-spacer>

                  <v-btn
                    v-if="!!course.theme && course.theme.length > 0"
                    depressed
                    color="warning"
                    @click="removeActiveTheme"
                  >
                    Effacer la sélection
                  </v-btn>

                  <v-btn depressed color="primary" @click="dialog = false">
                    Ajouter
                  </v-btn>
                </v-card-actions>
              </v-card-text>
            </v-card>
          </v-dialog>
          <!-- bouton droits utilisateurs & utilisateurs pour le mode edit -->
          <div v-if="mode === 'edit'" class="d-flex justify-content-between col-6">
            <!-- button dialog Droits utilisateurs-->
            <div>
              <v-dialog v-model="dialogUserRight" width="600px" max-height="400px">
                <template v-slot:activator="{ on }">
                  <v-btn color="primary" dark v-on="on">Liste des droits utilisateurs</v-btn>
                </template>
                <v-card>
                  <v-card-title>
                    <span class="headline pl-2">Nom des droits utilisateurs</span>
                  </v-card-title>
                  <v-card-text>
                    <!-- Display droits utilisateurs -->
                    <div class="py-5">
                      <!-- <v-simple-table fixed-header dense>
                        <tr class="py-0" v-for="item in userRights" :key="item.id" >
                          <td style="font-size:13px">{{ item.name }}</td>
                        </tr>
                      </v-simple-table> -->
                      <v-simple-table fixed-header dense>
                        <tr class="py-0" v-for="item in userRights" :key="item.id" >
                          <td style="font-size:13px">{{ item.name }}</td>
                        </tr>
                      </v-simple-table>
                    </div>
                  </v-card-text>
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="primary" text @click="dialogUserRight = false">Fermer</v-btn>
                  </v-card-actions>
                </v-card>
              </v-dialog>
            </div>

            <!-- button dialog Utilisateurs-->
            <div>
              <v-dialog v-model="dialogUser" width="600px" max-height="400px">
                <template v-slot:activator="{ on }">
                  <v-btn color="primary" dark v-on="on">Utilisateurs</v-btn>
                </template>
                <v-card>
                  <v-card-title>
                    <span class="headline pl-2">Liste des utilisateurs</span>
                  </v-card-title>
                  <v-card-text>
                    <!-- Display utilisateur -->
                    <div class="py-5">
                      <v-simple-table fixed-header dense>
                        <div class="py-0" v-for="u in userRights" :key="u.id" >
                          <div class="py-0" v-for="item in u" :key="item.id">
                            <tr class="py-0" v-for="i in item" :key="i.id">
                              <td v-if="item" style="font-size:13px">{{ i.firstname }} {{ i.lastname }}</td>
                            </tr>
                          </div>
                        </div>
                      </v-simple-table>
                    </div>
                  </v-card-text>
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="primary" text @click="dialogUser = false">Fermer</v-btn>
                  </v-card-actions>
                </v-card>
              </v-dialog>
            </div>
          </div>

          <!-- bouton droits utilisateurs & utilisateurs pour le mode add -->
          <div v-if="mode === 'add' " class="d-flex justify-content-between col-6">
            <!-- button dialog Droits utilisateurs-->
            <div>
              <v-dialog v-model="dialogUserRight" width="600px" max-height="400px">
                <template v-slot:activator="{ on }">
                  <v-btn color="primary" dark v-on="on">Liste des droits utilisateurs</v-btn>
                </template>
                <v-card>
                  <v-card-title>
                    <span class="headline pl-2">Nom des droits utilisateurs</span>
                  </v-card-title>
                  <v-card-text>
                    <!-- Display droits utilisateurs -->
                    <div class="py-5">
                      <!-- <v-simple-table fixed-header dense>
                        <tr class="py-0" v-for="item in userRights" :key="item.id" >
                          <td style="font-size:13px">{{ item.name }}</td>
                        </tr>
                      </v-simple-table> -->
                      <v-simple-table fixed-header dense>
                        <tr class="py-0" v-for="item in userRights" :key="item.id" >
                          <td style="font-size:13px">{{ item.name }}</td>
                        </tr>
                      </v-simple-table>
                    </div>
                  </v-card-text>
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="primary" text @click="dialogUserRight = false">Fermer</v-btn>
                  </v-card-actions>
                </v-card>
              </v-dialog>
            </div>

            <!-- button dialog Utilisateurs-->
            <div>
              <v-dialog v-model="dialogUser" width="600px" max-height="400px">
                <template v-slot:activator="{ on }">
                  <v-btn color="primary" dark v-on="on">Utilisateurs</v-btn>
                </template>
                <v-card>
                  <v-card-title>
                    <span class="headline pl-2">Liste des utilisateurs</span>
                  </v-card-title>
                  <v-card-text>
                    <!-- Display utilisateur -->
                    <div class="py-5">
                      <v-simple-table fixed-header dense>
                        <div class="py-0" v-for="u in userRights" :key="u.id" >
                          <div class="py-0" v-for="item in u" :key="item.id">
                            <tr class="py-0" v-for="i in item" :key="i.id">
                              <td v-if="item" style="font-size:13px">{{ i.firstname }} {{ i.lastname }}</td>
                            </tr>
                          </div>
                        </div>
                      </v-simple-table>
                    </div>
                  </v-card-text>
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="primary" text @click="dialogUser = false">Fermer</v-btn>
                  </v-card-actions>
                </v-card>
              </v-dialog>
            </div>
          </div>

        </div>
      </div>
    </div>
  </div>
</template>
<script>


//import FileDrop from "@/components/files/FileDrop.vue";
import Api from "@/core/services/api.service";
import userParentThemes from "@/core/utils/userParentThemes";

export default {
  name: "formCourseStep1",
  // components: {
  //   FileDrop,
  // },

//On retrouve ici le v-model: formData envoyé par le parent. J'ai décidé de le renommer "course"
// + d'infos voir v-model custom, ou nested v-model
  model: {
    prop: "course",
    event: "input",
  },
  props: {
    course: Object,
    mode: String,
  },
  data: () => ({
    titleErrors: [
        (v) => !!v || "Le titre du parcours est obligatoire.",
        (v) => v.length >= 2 || "Le titre doit être supérieur à 2 caractères",
      ],
      descErrors: [
        (v) => !!v || "La description du parcours est obligatoire.",
        (v) => v.length >= 2 || "La description doit être supérieure à 2 caractères",
      ],
    newFile: null,
    keywords: {
      visibleFR: [],
      invisibleFR: [],
    },
    themes: [],
    open: [1, 2],
    search: null,
    caseSensitive: false,
    className: null,
    urlNewFile: null,
    userRights: [],
    dialog: false,
    dialogUserRight: false,
    dialogUser: false,
    isLoading: false,
  }),
  computed: {
    apiUrl() {
      return process.env.VUE_APP_API;
    },
    filter() {
      return this.caseSensitive
        ? (item, search, textKey) => item[textKey].indexOf(search) > -1
        : undefined;
    },
  },
  mounted() {
    this.getKeywords();
    this.isEditing();
    this.isLoading=true;
    //this.themeId = this.course.theme[0]['@id']
    Api.get("themes").then(themes => (this.themes = userParentThemes(themes.data["hydra:member"])));

    if(typeof this.course.theme[0] !== "undefined"){
      Api.query("user_rights",{ params: { themes: this.course.theme[0]['@id'] } })
      .then(userRights => {
          this.userRights = userRights.data["hydra:member"];
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => (this.isLoading = false));
        // recuperer droit utilisateur + user qu'il faut mettre dans un tableau en affichage
    }
  },
  methods: {
    required(value) {
      if (value instanceof Array && value.length == 0) {
        return 'Vous devez choisir ou créer un mot-clé';
      }
      return !!value || 'Vous devez choisir ou créer un mot-clé';
    },
    getKeywords() {
      Api.get("keywords").then((keywords) => {
        keywords.data["hydra:member"].forEach((keyword) => {
          if (keyword.isVisible == true) {
            if (keyword.lang === "FR") {
              // Je range tout les tags dans un tableau pour savoir s'ils sont visibles ou non
              this.keywords.visibleFR.push(keyword);
            }
          } else {
            if (keyword.lang == "FR") {
              this.keywords.invisibleFR.push(keyword);
            }
          }
        });
      });
    },
    isEditing() {
      if (this.course.id) {
        this.className = "col-xl-9";
      }
      else{
        this.className = "col-xl-12"
      }
    },
    removeActiveTheme() {
      this.course.theme = [];
    },
    // updatePoster(e) {
    //   console.log(e);
    //   this.newFile = e;
    //   this.urlNewFile = URL.createObjectURL(e);
    //   // this.poster.push(e);
    //   this.$emit("input", { ...this.course, posterFile: e });
    // },
    themeSelected(selected){
      this.course.theme = selected;
      Api.query("user_rights",{ params: { themes: this.course.theme[0]['@id'] } })
      .then(userRights => {
          this.userRights = userRights.data["hydra:member"];
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => (this.isLoading = false));
    },
  },
};
</script>
